(() => {
  const config = document.querySelector('[data-emz-results-return-script]');
  if (!config || (window.Shopify && window.Shopify.designMode)) return;

  const getResults = () => {
    try {
      if (!document.referrer) return null;
      const url = new URL(document.referrer);
      if (url.origin !== window.location.origin || url.username || url.password) return null;
      if (['section_id', 'sections', 'view'].some(key => url.searchParams.has(key))) return null;

      const searchPath = new URL(config.dataset.searchUrl, window.location.origin).pathname;
      const collectionsPath = new URL(config.dataset.collectionsUrl, window.location.origin).pathname.replace(/\/$/, '');
      const path = url.pathname.replace(/\/$/, '');
      const articleId = config.dataset.articleId;
      const articleTarget = config.dataset.searchOnly === 'true' && /^[1-9]\d*$/.test(articleId || '')
        ? '#emz-result-article-' + articleId : '';
      let preserveLabel = false;
      let label;

      if (path === searchPath.replace(/\/$/, '')) {
        if (!url.searchParams.get('q') || !url.searchParams.get('q').trim()) return null;
        label = config.dataset.searchLabel;
      } else if (config.dataset.searchOnly === 'true' && config.dataset.blogUrl) {
        const blogUrl = new URL(config.dataset.blogUrl, window.location.origin);
        if (blogUrl.origin !== window.location.origin || blogUrl.username || blogUrl.password) return null;
        const blogPath = blogUrl.pathname.replace(/\/$/, '');
        if (path === blogPath) {
          if (!url.search) {
            if (!articleTarget) return null;
            preserveLabel = true;
          }
        } else if (path.startsWith(blogPath + '/tagged/')) {
          const tag = decodeURIComponent(path.slice((blogPath + '/tagged/').length));
          if (tag.split('+').some(part => !part.trim()) || /[\/\\\u0000-\u001f\u007f]/.test(tag)) return null;
        } else {
          return null;
        }
        if (!preserveLabel) label = config.dataset.blogLabel;
      } else if (config.dataset.searchOnly !== 'true' && path.startsWith(collectionsPath + '/')) {
        const segments = path.slice(collectionsPath.length + 1).split('/');
        if (segments.length > 2 || !/^[a-z0-9][a-z0-9-]*$/.test(segments[0])) return null;
        if (segments.length === 2) {
          const tag = decodeURIComponent(segments[1]);
          if (!tag || tag === 'products' || /[\/\\\u0000-\u001f\u007f]/.test(tag)) return null;
        }
        label = config.dataset.collectionLabel;
      } else {
        return null;
      }

      if (!label && !preserveLabel) return null;
      const productId = config.dataset.productId;
      const fragment = config.dataset.searchOnly !== 'true' && /^[1-9]\d*$/.test(productId || '')
        ? '#emz-result-product-' + productId
        : articleTarget;
      return { href: url.pathname + url.search + fragment, label };
    } catch (error) {
      return null;
    }
  };

  const enhance = () => {
    const results = getResults();
    if (!results) return;
    document.querySelectorAll('[data-emz-results-return]').forEach(link => {
      link.setAttribute('href', results.href);
      const label = link.querySelector('[data-emz-results-return-label]') || link;
      if (results.label) label.textContent = results.label;
      link.classList.add('emz-results-return');
      const container = link.closest('[data-emz-results-return-container]');
      if (container) container.hidden = false;
    });
  };

  enhance();
  window.addEventListener('pageshow', enhance);
})();
